/** A util to check whether the object has a key, while inferring the correct key type */
function hasOwnProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
export { hasOwnProperty };
//# sourceMappingURL=has-own-property.js.map